export const grayColors = {
    black: "#000000",
    gray013: "#0d0d0d",
    gray023: "#171717",
    gray033: "#212121",
    gray043: "#2b2b2b",
    gray053: "#353535",
    gray063: "#3f3f3f",
    gray073: "#494949",
    gray083: "#535353",
    gray093: "#5d5d5d",
    gray103: "#676767",
    gray113: "#717171",
    gray123: "#7b7b7b",
    gray133: "#858585",
    gray143: "#8f8f8f",
    gray153: "#999999",
    gray163: "#a3a3a3",
    gray173: "#adadad",
    gray183: "#b7b7b7",
    gray193: "#c1c1c1",
    gray203: "#cbcbcb",
    gray213: "#d5d5d5",
    gray223: "#dfdfdf",
    gray233: "#e9e9e9",
    gray243: "#f3f3f3",
    gray253: "#fdfdfd",
    white: "#ffffff",
    transparent: "transparent"
}